import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/appInsights';

function getPageName(pathname) {
  if (pathname === '/') return 'Home';
  if (pathname.includes('/outlook')) return 'Outlook';
  if (pathname.includes('/overview')) return 'Overview';
  if (pathname.includes('/recent-publications')) return 'Recent Publications';
  if (pathname.includes('/admin')) return 'Admin';
  if (pathname.includes('/profile')) return 'Profile';
  if (pathname.includes('/privacy')) return 'Privacy Policy';
  return pathname;
}

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const name = getPageName(location.pathname);
    trackPageView(name, location.pathname + location.search, {
      routePath: location.pathname,
    });
  }, [location.pathname]);
}
